var exports = {
  "N": "ActivityViewSlot.module__slot___ancwem",
};

module.exports = exports;
